import axios from "axios";
import { useGlobalStore } from "controller/store/globalStore";
import { debugConsole } from "./debugConsole";

let isLoading = false;

/**
 * Decodes a JWT token and extracts the payload
 * @param token - JWT token string
 * @returns Decoded token payload
 */
export const decodeJwtToken = (token: string): any => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    debugConsole("Failed to decode JWT token", error);
    throw new Error("Invalid JWT token");
  }
};

export const internalAxiosClient = axios.create({
  baseURL: import.meta.env["VITE_APP_BASE_URL"],
});

internalAxiosClient.interceptors.request.use((req) => {
  return req;
});

export const setSessionValues = async (
  accessToken: string,
  decodedData: any
) => {
  useGlobalStore.setState((state) => ({
    ...state,
    accessToken: accessToken,
    mspId: decodedData?.tenantId,
    resourceId: decodedData?.sub,
    name: state.name,
    email: decodedData?.email,
    profilePictureUrl: state.profilePictureUrl,
    roles: decodedData?.roles,
    permissions: decodedData?.permissions,
  }));
};

export const logoutUnauthenticatedUser = async (
  signout: (url: string) => Promise<void>
) => {
  if (!isLoading) {
    isLoading = true;
    const redirectUrl = `${window.location.origin}/login`;

    localStorage.clear();
    sessionStorage.clear();
    await signout(redirectUrl);
    isLoading = false;
  }

  return null;
};
